import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectedPageInfo = createSelector(
    [state => state.pages, state => state.flag],
    (pages, { selectPageId }) => {
        const formPages = pages.filter(page => page.type === 1 && !page.deleted);
        formPages.sort((a, b) => a.seq - b.seq);
        const selectedPageIndex = formPages.findIndex(page => page.id === selectPageId);
        const nextPage = formPages[selectedPageIndex + 1] || {};
        const prevPage = formPages[selectedPageIndex - 1] || {};
        const { id: firstPageId } = formPages[0] || {};
        const { id: lastPageId } = formPages[formPages.length - 1] || {};
        return {
            isFirstPage: selectPageId === firstPageId,
            isLastPage: selectPageId === lastPageId,
            isOnePage: formPages.length === 1,
            nextPageId: nextPage.id,
            prevPageId: prevPage.id
        };
    }
);

export default function useSelectedPageInfo() {
    return useSelector(selectedPageInfo);
}
